// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Nexa-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Nexa-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cormorant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cormorant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Cormorant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Cormorant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Cormorant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Bruney.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/GeneralSans-Extralight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/GeneralSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-style: normal;
  font-weight: 700;
}
@font-face {
  font-family: "Bruney";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-style: normal;
  font-weight: 700;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

body {
  font-family: GeneralSans, sans-serif;
}

.about__parentmobile {
  padding-bottom: 2rem;
  border-bottom: 1px solid rgb(238, 234, 234);
}
.about__photo {
  border-radius: 4px;
  height: 11rem;
  margin-top: 2rem;
  margin-left: 2rem;
}
@media (min-width: 1280px) {
  .about__photo {
    margin-top: 4rem;
    height: 15rem;
    margin-left: 9rem;
  }
}
@media (min-width: 768px) {
  .about__wrappermobile {
    display: none;
  }
}
.about__maintitlemobile {
  font-size: 1.3rem;
  padding: 1rem 1rem 0 1rem;
  text-align: center;
}
.about__titlemobile {
  font-size: 1rem;
  font-weight: 400;
  padding-top: 0.4rem;
  padding-bottom: 0.8rem;
  text-align: center;
}
.about__contentmobile {
  padding-right: 1rem;
  padding-left: 1rem;
  padding-top: 1rem;
  text-align: center;
  font-size: 0.8rem;
  line-height: 1.3rem;
}
@media (min-width: 450px) {
  .about__contentmobile {
    width: 90%;
    margin: auto;
  }
}
.about__buttonmobile {
  margin-top: 2rem;
  display: block;
  margin: auto;
}
.about__photomobile {
  width: 70%;
  border-radius: 4px;
  display: block;
  margin: auto;
}
.about__wrapper {
  display: none;
}
@media (min-width: 768px) {
  .about__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media (min-width: 1280px) {
  .about__wrapper {
    margin: auto;
    max-width: 79rem;
  }
}
.about__maintitle {
  color: #2f020c;
  font-size: 1.6rem;
  font-family: "bruney";
  padding-left: 5rem;
}
@media (min-width: 1280px) {
  .about__maintitle {
    font-size: 3rem;
  }
}
.about__parent {
  padding: 2rem 2rem;
  width: 70%;
  margin: auto;
  font-size: 1.3rem;
  line-height: 2rem;
  max-width: 1000px;
}
@media (min-width: 1280px) {
  .about__parent {
    padding-top: 6rem;
  }
}
.about__title {
  color: #2f020c;
  font-family: "cormorant";
  font-weight: 400;
  padding-top: 1.5rem;
  font-size: 1.7rem;
}
@media (min-width: 1280px) {
  .about__title {
    padding-left: 4.5rem;
  }
}
.about__content {
  display: none;
}
@media (min-width: 768px) {
  .about__content {
    display: flex;
    padding-top: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
    padding: 2rem 2rem 3rem 2rem;
    max-width: 1000px;
    margin: auto;
    border-bottom: 1px solid rgb(238, 234, 234);
  }
}
@media (min-width: 1280px) {
  .about__content {
    padding-top: 2rem;
    font-size: 1.3rem;
    padding-left: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/partials/_typography.scss","webpack://./src/components/About/About.scss","webpack://./src/styles/partials/_global.scss","webpack://./src/styles/partials/_mixins.scss","webpack://./src/styles/partials/_variables.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ACzEA;;;EAGI,sBAAA;EACA,SAAA;AD2EJ;;ACzEA;EACI,oCAAA;AD4EJ;;AAjFI;EACI,oBAAA;EACA,2CAAA;AAoFR;AAlFI;EACI,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AAoFR;AE1FI;EFEA;IAMI,gBAAA;IACA,aAAA;IACA,iBAAA;EAsFN;AACF;AEtGI;EFkBA;IAEQ,aAAA;EAsFV;AACF;AApFI;EACI,iBAAA;EACA,yBAAA;EACA,kBAAA;AAsFR;AApFI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAsFR;AApFI;EACI,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAsFR;AEpHI;EFwBA;IAQQ,UAAA;IACA,YAAA;EAwFV;AACF;AAtFI;EACI,gBAAA;EACA,cAAA;EACA,YAAA;AAwFR;AAtFI;EACI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAwFR;AAtFI;EACI,aAAA;AAwFR;AEnJI;EF0DA;IAGQ,aAAA;IACA,uBAAA;IACA,mBAAA;EA0FV;AACF;AErJI;EFqDA;IAQQ,YAAA;IACA,gBAAA;EA4FV;AACF;AA1FI;EACI,cG/DU;EHgEV,iBAAA;EACA,qBAAA;EACA,kBAAA;AA4FR;AEjKI;EFiEA;IAMQ,eAAA;EA8FV;AACF;AA5FI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AA8FR;AE9KI;EF0EA;IAQQ,iBAAA;EAgGV;AACF;AA9FI;EACI,cGnFU;EHoFV,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAgGR;AE1LI;EFqFA;IAOQ,oBAAA;EAkGV;AACF;AAhGI;EACI,aAAA;AAkGR;AEvMI;EFoGA;IAGQ,aAAA;IACA,iBAAA;IACA,kBAAA;IACA,mBAAA;IACA,4BAAA;IACA,iBAAA;IACA,YAAA;IACA,2CAAA;EAoGV;AACF;AE9MI;EF+FA;IAaQ,iBAAA;IACA,iBAAA;IACA,kBAAA;EAsGV;AACF","sourcesContent":["@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Bold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Light.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Regular.ttf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Medium.ttf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-SemiBold.ttf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Bold.ttf);\n    font-style: normal;\n    font-weight: 700;\n}\n@font-face{\n    font-family: \"Bruney\";\n    src: url(../../assets/fonts/Bruney.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Extralight.otf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Regular.otf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Semibold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Bold.otf);\n    font-style: normal;\n    font-weight: 700;\n}\n","@use \"../../styles/partials/variables\" as *;\n@use \"../../styles/partials/typography\" as *;\n@use \"../../styles/partials/mixins\" as *;\n@use \"../../styles/partials/_global\" as *;\n\n.about{\n    &__parentmobile{\n        padding-bottom: 2rem;\n        border-bottom: 1px solid $website-border-lightgray;\n    }\n    &__photo{\n        border-radius: 4px;\n        height: 11rem;\n        margin-top: 2rem;\n        margin-left: 2rem;\n    @include desktop{\n        margin-top: 4rem;\n        height: 15rem;\n        margin-left: 9rem;\n    }\n    }\n    &__wrappermobile{\n        @include tablet-and-desktop{\n            display: none;\n        }\n    }\n    &__maintitlemobile{\n        font-size: 1.3rem;\n        padding: 1rem 1rem 0 1rem;\n        text-align: center;\n    }\n    &__titlemobile{\n        font-size: 1rem;\n        font-weight: 400;\n        padding-top: 0.4rem;\n        padding-bottom: 0.8rem;\n        text-align: center;\n    }\n    &__contentmobile{\n        padding-right: 1rem;\n        padding-left: 1rem;\n        padding-top: 1rem;\n        text-align: center;\n        font-size: 0.8rem;\n        line-height: 1.3rem;\n        @include big-mobile-screen{\n            width: 90%;\n            margin: auto\n        }\n    }\n    &__buttonmobile{\n        margin-top: 2rem;\n        display: block;\n        margin: auto;\n    }\n    &__photomobile{\n        width: 70%;\n        border-radius: 4px;\n        display: block;\n        margin: auto;\n    }\n    &__wrapper{\n        display: none;\n        @include tablet-and-desktop{\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n        @include desktop{\n            margin: auto;\n            max-width: 79rem;\n        }\n    }\n    &__maintitle{\n        color: $xeus-darkmaroon;\n        font-size: 1.6rem;\n        font-family: \"bruney\";\n        padding-left: 5rem;\n        @include desktop{\n            font-size: 3rem;\n        }\n    }\n    &__parent{\n        padding: 2rem 2rem;\n        width: 70%;\n        margin: auto;\n        font-size: 1.3rem;\n        line-height: 2rem;\n        max-width: 1000px;\n        @include desktop{\n            padding-top: 6rem;\n        }\n    }\n    &__title{\n        color: $xeus-darkmaroon;\n        font-family: 'cormorant';\n        font-weight: 400;\n        padding-top: 1.5rem;\n        font-size: 1.7rem;\n        @include desktop{\n            padding-left: 4.5rem;\n        }\n    }\n    &__content{\n        display: none;\n        @include tablet-and-desktop{\n            display: flex;\n            padding-top: 2rem;\n            padding-left: 2rem;\n            padding-right: 2rem;\n            padding: 2rem 2rem 3rem 2rem;\n            max-width: 1000px;\n            margin: auto;\n            border-bottom: 1px solid $website-border-lightgray;\n        }\n        @include desktop{\n            padding-top: 2rem;\n            font-size: 1.3rem;\n            padding-left: 1rem;\n        }\n    }\n}","@use \"./variables\" as *;\n@use \"./typography\" as *;\n@use \"./mixins\" as *;\n\n*,\n*::before,\n*::after{\n    box-sizing: border-box;\n    margin: 0;\n}\nbody{\n    font-family: GeneralSans, sans-serif;\n}\n","@use \"./variables\" as *;\n\n@mixin tablet-and-desktop {\n    @media (min-width: $tablet-breakpoint) {\n        @content;\n    }\n}\n@mixin desktop {\n    @media (min-width: $desktop-breakpoint) {\n        @content;\n    }\n}\n\n@mixin big-mobile-screen {\n    @media (min-width: 450px) {\n        @content;\n    }\n}","$tablet-breakpoint: 768px;\n$desktop-breakpoint: 1280px;\n$max-width: 1195px;\n$mobile-header-fontsize: 1rem;\n$mobile-subheader-fontsize: 0.9rem;\n$mobile-content-fontsize: 0.8rem;\n$text-darkgray: rgb(39, 32, 32);\n$text-shadow: #3d3d3d;\n$button-color: #2f7fb0;\n$button-color-hover: #0c4f76;\n$website-darkgray: rgb(44, 43, 43);\n$xeus-darkmaroon: #2f020c;\n$xeus-mediumbeige: rgb(224, 196, 154);\n$xeus-lightbeige: rgb(243, 226, 201);\n$website-border-lightgray: rgb(238, 234, 234);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
